import { apiCallWrapper, SelectOptionModel } from 'traveldesk-ui'
import { TourImportModel } from '../pages/TourImport/TourImportModel'

export default class ExternalIntegrationsApiService {
    public static async getApiIntegrations(dispatch: any) {
        return await apiCallWrapper<SelectOptionModel[]>('/api/externalintegrations', 'GET', dispatch)
    }
    public static async getExternalTours(dispatch: any, apiIntegrationId: string) {
        return await apiCallWrapper<SelectOptionModel[]>('/api/externalintegrations/tours?apiProviderId=' + apiIntegrationId, 'GET', dispatch)
    }
    public static async getExternalTour(dispatch: any, tourId: string, apiIntegrationId: string) {
        return await apiCallWrapper<TourImportModel>(`/api/externalintegrations/tours/${tourId}?apiProviderId=${apiIntegrationId}`, 'GET', dispatch)
    }
    public static async getExternalCategoriesMappings(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCategoryMappingModel[]>('/api/externalintegrations/categories?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async saveExternalCategoriesMapping(dispatch: any, category: ExternalCategoryMappingPostModel) {
        return await apiCallWrapper<ExternalCategoryMappingModel>('/api/externalintegrations/categories', 'POST', dispatch, category)
    }
    public static async getExternalCitiesMappings(dispatch: any, apiProviderId: string) {
        return await apiCallWrapper<ExternalCityMappingModel[]>('/api/externalintegrations/cities?apiProviderId=' + apiProviderId, 'GET', dispatch)
    }
    public static async saveExternalCitiesMapping(dispatch: any, city: ExternalCityMappingPostModel) {
        return await apiCallWrapper<ExternalCityMappingModel>('/api/externalintegrations/cities', 'POST', dispatch, city)
    }
}
export interface ExternalCityMappingModel {
    apiIntegrationCityId: string
    apiIntegrationCityName: string
    ourCityId: number
}
export interface ExternalCategoryMappingModel {
    apiIntegrationCategoryId: string
    apiIntegrationCategoryName: string
    ourCategoryId: number
}
export interface ExternalCategoryMappingPostModel {
    apiProviderId: number
    categoryId: number
    externalCategoryId: string
}
export interface ExternalCityMappingPostModel {
    apiProviderId: number
    cityId: number
    externalCityId: string
}